import React, { useState, useEffect, useRef, useCallback } from "react";
import { useForm } from "react-hook-form";
import { Button } from "../../primary";
import { CANCEL_ID, CANCEL_BTN, SUBMIT_ID, SAVE_BTN } from "../../../constants";
import styles from "./assign.module.scss";
import { Modal } from "../../secondary";
import AsyncTagSelect from "../../secondary/AsyncTagSelect/AsyncTagSelect";

export const AddMaterial = ({
  modalOpen,
  modalClose,
  getMaterialCode,
  index,
  materialList,
  pIndex,
  defaultValue,
  productMaterial,
}) => {
  const { reset } = useForm();
  const [materialCodeTag, setMaterialCodeTag] = useState([]);

  useEffect(() => {
    if (productMaterial?.length > 0) {
      const materialCodeDef = productMaterial
        .map((item) => ({ value: item, label: item }))
        .sort((a, b) => (a.value > b.value ? 1 : -1));
      setMaterialCodeTag(materialCodeDef);
    }
  }, [materialList, defaultValue, modalOpen, productMaterial]);

  const handleMaterialCodeChange = useCallback((selectedOptions) => {
    setMaterialCodeTag(selectedOptions || []);
  }, []);

  const loadMaterialOptions = useCallback((query, callback) => {
    const options = Array.isArray(materialList?.data?.options)
      ? materialList.data.options
          .filter((item) =>
            item.exactMaterialNumber?.toLowerCase().includes(query.toLowerCase())
          )
          .map((item) => ({
            value: item.exactMaterialNumber,
            label: item.exactMaterialNumber,
          }))
      : [];
    callback(options);
  }, [materialList]);

  const addMaterialCode = () => {
    const defaultMaterialCodeBuket = materialCodeTag.map((e) => e.value);
    getMaterialCode(defaultMaterialCodeBuket, index, pIndex);
    modalClose();
  };

  const modalRefresh = () => {
    reset();
    modalClose();
  };

  const handleCancel = (e) => {
    reset();
    e.preventDefault();
    modalClose();
  };

  return (
    <Modal
      modalOpen={modalOpen}
      modalClose={modalRefresh}
      heading={
        productMaterial?.length > 0
          ? "Edit Material #"
          : "Select Material #"
      }
      className={"modal_box"}
      modalSize={styles.custom_modal_size_family}
      reset={reset}
    >
      <div className={`pl-2 ${styles.patient_content} addFamily`}>
        <div className={`col-12 ${styles.col_spec}`}>
          <label className={`col-3 col-form-label ${styles.label_spec}`}>
            Material #:{" "}
          </label>
          <div className="col-9 p-0">
            <AsyncTagSelect
              tags={materialCodeTag}
              onLoad={loadMaterialOptions}
              handleChange={handleMaterialCodeChange}
              placeholder="Select material"
              inputId="materialCode"
              noOptionMessage="No material found"
            />
          </div>
        </div>

        <div className="col-sm-12">
          <div className="text-center pb-4">
            <Button
              classes={{
                className: `btn ${styles.btn_custom} ${styles.btn_small}`,
              }}
              type="button"
              id={SUBMIT_ID}
              onClick={() => addMaterialCode()}
            >
              {SAVE_BTN}
            </Button>
            <Button
              classes={{
                className: `btn ${styles.btn_custom} ${styles.btn_small_cancel} handleCancel`,
              }}
              id={CANCEL_ID}
              onClick={handleCancel}
            >
              {CANCEL_BTN}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
